import type { FC } from 'react';
import React, { useContext, useMemo, useState } from 'react';

import { EditorContext, RicosContext, ToolbarContext, useTrackRender } from './../../../ricos-context';

import { MaxWidthCalculationWrapper } from '../../components/MaxWidthCalculationWrapper/MaxWidthCalculationWrapper';
import { Toolbar } from '../../components/Toolbar';
import { MOBILE_TOOLBAR } from './data-hooks';

export const MobileToolbar: FC = () => {
  useTrackRender('Mobile toolbar');

  const { isMobile, languageDir } = useContext(RicosContext);
  const { toolbars } = useContext(ToolbarContext);

  const {
    adapter: { tiptapEditor },
  } = useContext(EditorContext);
  const [maxWidth, setMaxWidth] = useState(tiptapEditor.view.dom.clientWidth);

  const toolbarItemsConfig = useMemo(
    () => toolbars.mobile.getToolbarItemsConfig(),
    [toolbars.mobile]
  );
  const toolbarItemsRenderers = useMemo(
    () => toolbars.mobile.getToolbarItemsRenderers(),
    [toolbars.mobile]
  );

  if (toolbars.mobile.isEmpty()) {
    return null;
  }

  return (
    <MaxWidthCalculationWrapper
      setMaxWidth={setMaxWidth}
      data-hook={MOBILE_TOOLBAR}
      dir={languageDir}
    >
      <Toolbar
        type="regular"
        maxWidth={maxWidth}
        isMobile={isMobile}
        toolbarItemsConfig={toolbarItemsConfig}
        toolbarItemsRenderers={toolbarItemsRenderers}
      />
    </MaxWidthCalculationWrapper>
  );
};
